module.exports = __webpack_public_path__ + "img/dan.f7b9ee37.png";